
import { gsap } from 'gsap';
import { ResizeHelper, IDimOrientation } from '../../dev/utils/ResizeHelper';
import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";
import { Helper } from '../../dev/utils/Helper';
import { TextStyleOptions } from '../../dev/setting/text/IText';
import { FontWeight } from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import { CarTypes } from '../server/data/GameDataModels';
import { MathHelper } from '../../dev/utils/MathHelper';
import { ArrayHelper } from '../../dev/utils/ArrayHelper';
import { RoadRage } from '../RoadRage';
import { SpinePlayer } from '../../dev/displayobject/SpinePlayer';

export class RoadRageReelOverlay extends PIXI.Container implements StageLayer {

    private bg_WIDTH: number = 1680;
    private baseSymSize: number = 144;

    private DEFAULT_TEXT_STYLE: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 6,
        fontFamily: "Helvetica",
        fontWeight: FontWeight.BOLD,
        fontSize: 90,
        align: "left",
        fill: [
            "white",
            "yellow",
            "red"
        ]
    };

    protected readonly reelDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(0, 160),
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(0, 160)
        }
    };

    protected _timelines: gsap.core.Timeline[] = [];
    protected _scatterMarked: PIXI.Graphics[] = [];

    protected _posDisabled: boolean[];

    protected reelDivder:PIXI.Sprite[] = [];

    public static instance:RoadRageReelOverlay;
    private bgPolice:SpinePlayer;

    constructor() {
        super();
        this.name = "RoadRageReelOverlay";
        RoadRageReelOverlay.instance = this;
        this.init();
    }

    protected init(): void {
        let xPosIndx:number = 0;

        this._posDisabled = ArrayHelper.initArrayWithValues(5,() => false);

        this.reelDivder.push(this.addChild(new PIXI.Sprite(RoadRage.assetLoader.getTextures("reelDiv")[0])));
        this.reelDivder.push(this.addChild(new PIXI.Sprite(RoadRage.assetLoader.getTextures("reelDiv")[0])));

        this.reelDivder.forEach((div,indx) => {
            div.anchor.set(0.5,0.5);
            div.x = 360;
            if(indx){
                div.scale.y = -1;
                div.position.y = 72 + 144*2;
            }else{
                div.position.y = -72;
            }
        });


        this.bgPolice = this.addChild(new SpinePlayer("Police_FS"))
        this.bgPolice.position.set(360,360);
        
        this.onResize();
    }

    setDisabled(val:boolean, reelPos:number | number[]):void{
        ArrayHelper.typeConvert(reelPos).forEach((v => this._posDisabled[v] = val));
    }

    reelSizeChange(sizeAmount:number,symSize:number){
        const newYPos:number = (sizeAmount === 3 ? 72 + 144*2 : sizeAmount == 4 ? 436  :  470);
        gsap.to(this.reelDivder[1],{y:newYPos,duration:0.25});
    }

    flashCarDirection(type:string,target:PIXI.DisplayObject, durr:number = 0.5, dirr:number){
        const arrow:PIXI.Text = this.addChild(new PIXI.Text("->",this.DEFAULT_TEXT_STYLE));
        let arrow2:PIXI.Text = this.addChild(new PIXI.Text("->",this.DEFAULT_TEXT_STYLE));
        arrow.anchor.set(0.5,0.5);
        arrow2.anchor.set(0.5,0.5);

        arrow.position = arrow2.position = Helper.copyLocalPosition(this,target);
        arrow.position.x = arrow2.position.x += -144/2;
        arrow.position.y = arrow2.position.y = target.y;
        
        if(type === CarTypes.YELLOW){

            if(dirr === 1)
                arrow.visible = false;
            else if(dirr === 2)
                arrow2.visible = false;

            arrow.rotation = MathHelper.degreeToAngle(-90);
            arrow2.rotation = MathHelper.degreeToAngle(90);

            arrow.pivot.y = arrow2.pivot.y = 6
            arrow.pivot.x = arrow2.pivot.x = -43
        }else{
            arrow2.destroy();
            arrow2 = undefined!;
        }

        if(type === CarTypes.RED) arrow.scale.x = -1;
        
        const tl:gsap.core.Timeline = new gsap.core.Timeline({onComplete:() => {
            arrow.destroy()
            if(arrow2) arrow2.destroy();
        }});

        tl.to(arrow,{alpha: 0,duration:durr},0);

        if(arrow2){
            tl.to(arrow2,{alpha: 0,duration:durr},0);
            tl.fromTo([arrow.pivot,arrow2.pivot],{x:-20},{x:-50,duration:durr},0);
        }else{
            tl.fromTo(arrow.pivot,{x:0},{x:-50,duration:durr},0);
        }

        return tl;
    }

    private createGraph():PIXI.Graphics{
        const graph:PIXI.Graphics = new PIXI.Graphics();

        graph.beginFill(0x0000FF, 0);
        graph.drawRect(-144*0.5, -144 * 0.5 - 8, 144 , 5);
        graph.endFill();
        return this.addChild(graph);
    }

    private glowTl:gsap.core.Timeline;
    public playLightning(active:boolean):void{

        this.glowTl = Helper.setTimeline(this.glowTl);

        if(active){
            this.bgPolice.alpha = 0.8;
            this.bgPolice.scale.set(1.05);
            this.bgPolice.position.set(360,120);
            this.bgPolice.scale.y = -this.bgPolice.scale.y;
            this.bgPolice.play({animation:"PoliceFS_Loop_B",loop:true,duration:2});
        }else{
            this.glowTl.to(this.bgPolice,{alpha:0,duration:0.25});
            this.glowTl.add(() => { this.bgPolice.stop();})
        }
    }

    private movingTL:gsap.core.Timeline;
    private _moveVal:number = 0;
    private set moveVal(val:number){ this._moveVal = val; } 
    switchBgMovement(durr:number, fromLeft:boolean,cb?:Function): void {
        
        const startX: number = 0;
        this.movingTL = Helper.setTimeline(this.movingTL, new gsap.core.Timeline({
            onUpdate:() =>{
                if(this.movingTL.progress() <= 0.5)
                    this.x = startX + Number(this._moveVal);
                else{
                    this.x = startX + (Number(this._moveVal) - Number(fromLeft ? -this.bg_WIDTH : this.bg_WIDTH));
                }
            }
        }));

        this.moveVal = startX;

        const startToX: number = 0 + (fromLeft ? -this.bg_WIDTH : this.bg_WIDTH);

        this.movingTL.to(this, { moveVal: startToX, duration: durr });
        
        this.movingTL.to(this, { alpha: 0, duration: durr/4},0)
        this.movingTL.to(this, { alpha: 1, duration: durr/2},durr/2)
    }

    onResize(): void {
        ResizeHelper.setDimForTarget(this,this.reelDim);
    }
}